import React from 'react';

export interface AdConfig {
  slot: string;
  route?: string;
  format: 'auto' | 'fluid' | 'autorelaxed';
  displayStyle: string;
  responsive: boolean;
  description: string;
  layout?: string;
  style?: React.CSSProperties;
  kind?: 'modal' | 'inline';
}

export const AdSlots: Record<string, AdConfig> = {
  login: {
    slot: '7547976279',
    route: "/login",
    format: 'autorelaxed',
    displayStyle: 'block',
    responsive: true,
    description: 'Login page ad - responsive autorelaxed format',
    kind: 'modal',
    style: {
      display: 'block',
      minHeight: '250px',
      width: '100%',
    },
  },
  createPost: {
    slot: '9679946485',
    route: "/dashboard/submit-post",
    format: 'auto',
    displayStyle: 'block',
    responsive: true,
    description: 'Create post page ad',
    kind: 'modal',
    style: {
      display: 'block',
      minHeight: '250px',
      width: '100%',
    },
  },
  articleStart: {
    slot: '8945449313',
    format: 'auto', 
    displayStyle: 'block',
    layout: 'in-article',
    responsive: true,
    description: 'Article start - in-article auto format',
    kind: 'inline',
    style: {
      display: 'block',
      textAlign: 'center',
      width: '100%',
      minHeight: '250px',
    },
  },
  articleMiddle: {
    slot: '5692803272',
    format: 'auto', 
    displayStyle: 'block',
    layout: 'in-article',
    responsive: true,
    description: 'Article middle - in-article auto format',
    kind: 'inline',
    style: {
      display: 'block',
      textAlign: 'center',
      width: '100%',
      minHeight: '250px', 
    },
  },
  guidelines: {
    slot: '5932476424',
    route: "/guidelines",
    format: 'autorelaxed',
    displayStyle: 'block',
    responsive: true,
    description: 'Guidelines page ad',
    kind: 'modal',
    style: {
      display: 'block',
      minHeight: '250px',
      width: '100%',
    },
  },
};


export type AdType = keyof typeof AdSlots;